import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import logEntidadeComponent from "@/components/child/logEntidade/logEntidade.vue";
import { Component, Prop, Watch } from "@/decorators";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import FinalidadeEmissao from "@/models/enum/finalidadeEmissao";
import TipoLogEntidade from "@/models/enum/tipoLogEntidade";
import TiposMovimentacao from "@/models/enum/tiposMovimentacao";
import Ufs from "@/models/enum/ufs";
import NaturezaOperacaoFinalidadeEmissaoModel from "@/models/naturezaOperacaoFinalidadeEmissaoModel";
import NaturezaOperacaoModel from "@/models/naturezaOperacaoModel";
import NaturezaOperacaoObservacaoModel from "@/models/naturezaOperacaoObservacaoModel";
import naturezaOperacaoService from "@/services/naturezaOperacaoService";
import situacaoTributariaService from "@/services/situacaoTributariaService";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        buttonIncluirComponent,
        comboComponent,
        checkboxComponent,
        decimalComSinalCustomComponent,
        dataTooltipComponent,
        gridComponent,
        fieldsetComponent,
        logEntidadeComponent,
    },
})
export default class NaturezaOperacaoEditComponent extends EditComponentBase<NaturezaOperacaoModel> {
    tiposMovimentacaoOptions: Array<Object> = [
        { text: "Entrada", value: TiposMovimentacao.Entrada },
        { text: "Saida", value: TiposMovimentacao.Saida },
    ];

    cstICMSOptions: Array<Object> = [];
    cstIPIOptions: Array<Object> = [];
    cstPISCOFINSOptions: Array<Object> = [];
    cstIBSCBSOptions: Array<Object> = [];

    ufObservacao: Ufs = null;
    observacaoTexto = "";
    ufOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(Ufs);

    gridColumnsObservacoesUF: Array<GridColumn> = [
        new GridColumn("ufDescricao", "UF", GridColumnType.String),
        new GridColumn("observacao", "Observação", GridColumnType.String),
    ];

    finalidadeEmissaoPermitidaId: FinalidadeEmissao | null = null;

    gridColumnsFinalidadesEmissao: Array<GridColumn> = [
        new GridColumn("finalidadeEmissaoDescricao", "Finalidade da Emissão", GridColumnType.String),
    ];

    finalidadesEmissaoOptions: Array<{ text: string; value: FinalidadeEmissao }> = [
        { text: "1-NF-e Normal", value: FinalidadeEmissao.Normal },
        { text: "2-NF-e Complementar", value: FinalidadeEmissao.Complementar },
        { text: "3-NF-e de Ajuste", value: FinalidadeEmissao.Ajuste },
        { text: "4-Devolução de mercadoria", value: FinalidadeEmissao.Devolucao },
        { text: "5-Nota de Crédito", value: FinalidadeEmissao.NotaCredito },
        { text: "6-Nota de Débito", value: FinalidadeEmissao.NotaDebito },
    ];

    get finalidadesEmissaoDisponiveisOptions() {
        const finalidadesSelecionadas = this.model?.finalidadesEmissao?.map(p => p.finalidadeEmissao) ?? [];

        return this.finalidadesEmissaoOptions.filter(p => !finalidadesSelecionadas.includes(p.value));
    }

    @Prop({ type: Boolean, default: false }) CalledByShortCut: boolean;

    private async beforeMount() {
        await this.setPropsCached(
            naturezaOperacaoService,
            "naturezas_de_operacao",
            new NaturezaOperacaoModel(),
            this.CalledByShortCut,
        );

        this.loadCSTs();
    }

    public async onPreLoadModel() {
        this.model.tipoMovimentacao = TiposMovimentacao.Entrada;
        this.model.dentroEstado = true;
        this.model.movimentaEstoque = true;
        this.model.transferencia = false;
        this.newModel.finalidadesEmissao = this.getFinalidadesEmissaoPadrao();
        return true;
    }

    private getFinalidadesEmissaoPadrao(): Array<NaturezaOperacaoFinalidadeEmissaoModel> {
        return this.finalidadesEmissaoOptions.map(opcao => {
            const finalidade = new NaturezaOperacaoFinalidadeEmissaoModel();
            finalidade.finalidadeEmissao = opcao.value;
            finalidade.finalidadeEmissaoDescricao = opcao.text;
            return finalidade;
        });
    }

    get tipoLogEntidadeNaturezaOperacao(): number {
        return TipoLogEntidade.NaturezaOperacao;
    }

    //@ts-ignore
    @Watch("model.codigo")
    private onChangeCodigo() {
        if (!this.model.id && this.model.codigo.toString().length > 3) {
            switch (Number(this.model.codigo[0])) {
                case 1:
                    this.model.dentroEstado = true;
                    this.model.tipoMovimentacao = TiposMovimentacao.Entrada;
                    break;
                case 2:
                    this.model.dentroEstado = false;
                    this.model.tipoMovimentacao = TiposMovimentacao.Entrada;
                    break;
                case 5:
                    this.model.dentroEstado = true;
                    this.model.tipoMovimentacao = TiposMovimentacao.Saida;
                    break;
                case 6:
                    this.model.dentroEstado = false;
                    this.model.tipoMovimentacao = TiposMovimentacao.Saida;
                    break;
            }
        }
    }

    private async loadCSTs() {
        if (this.usuarioLogado.franquia.opcaoSimplesNacional) {
            this.cstICMSOptions = situacaoTributariaService
                .getCSOSN()
                .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));
        } else {
            this.cstICMSOptions = situacaoTributariaService
                .getICMS()
                .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));
        }

        this.cstIPIOptions = situacaoTributariaService
            .getIPI()
            .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));
        this.cstPISCOFINSOptions = situacaoTributariaService
            .getPISCOFINS()
            .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));

        this.cstIBSCBSOptions = situacaoTributariaService.getIBSCBS();
    }

    private async onInclusaoObservacaoUF() {
        if (!this.model.observacoes) {
            this.model.observacoes = [];
        }

        if (this.model.observacoes.find(obs => obs.uf === this.ufObservacao)) {
            this.$showError(
                this.$t("__.Crud.naturezaoperacao.edit_vue_html.ufJaCadastrada"),
                `${this.$t(
                    "__.Crud.naturezaoperacao.edit_vue_html.jaExisteObservacaoUF",
                )}: ${EnumExtensions.getNameByValue(Ufs, this.ufObservacao)}`,
            );
            return;
        }

        const novaObservacao = new NaturezaOperacaoObservacaoModel();
        novaObservacao.naturezaOperacaoId = this.model.id;
        novaObservacao.uf = this.ufObservacao;
        novaObservacao.observacao = this.observacaoTexto;
        novaObservacao.ufDescricao = EnumExtensions.getNameByValue(Ufs, this.ufObservacao);

        this.model.observacoes.push(novaObservacao);

        this.ufObservacao = null;
        this.observacaoTexto = "";
    }

    private async onRemoveObservacaoUF(observacao: NaturezaOperacaoObservacaoModel) {
        const index = this.model.observacoes.findIndex(obs => obs === observacao);
        if (index > -1) {
            this.model.observacoes.splice(index, 1);
        }
    }

    private onInclusaoFinalidadeEmissao() {
        if (!this.model.finalidadesEmissao) {
            this.model.finalidadesEmissao = [];
        }

        if (this.finalidadeEmissaoPermitidaId == null) {
            return;
        }

        if (this.model.finalidadesEmissao.some(p => p.finalidadeEmissao == this.finalidadeEmissaoPermitidaId)) {
            return this.$showError(
                this.$t("__.Crud.naturezaoperacao.edit_vue_html.finalidadeEmissao"),
                this.$t("__.Crud.naturezaoperacao.edit_vue_html.finalidadeEmissaoJaIncluida"),
            );
        }

        const finalidadeEmissao = new NaturezaOperacaoFinalidadeEmissaoModel();
        finalidadeEmissao.naturezaOperacaoId = this.model.id ?? 0;
        finalidadeEmissao.finalidadeEmissao = this.finalidadeEmissaoPermitidaId;
        finalidadeEmissao.finalidadeEmissaoDescricao = this.getFinalidadeEmissaoDescricao(
            this.finalidadeEmissaoPermitidaId,
        );

        this.model.finalidadesEmissao.push(finalidadeEmissao);
        this.finalidadeEmissaoPermitidaId = null;
    }

    private onRemoveFinalidadeEmissao(finalidadeEmissao: NaturezaOperacaoFinalidadeEmissaoModel) {
        this.model.finalidadesEmissao = this.model.finalidadesEmissao.filter(p => p != finalidadeEmissao);
    }

    private getFinalidadeEmissaoDescricao(finalidadeEmissao: FinalidadeEmissao) {
        return this.finalidadesEmissaoOptions.find(p => p.value == finalidadeEmissao)?.text ?? "";
    }
}
